/** How the server's `missingForInvoicing` keys are named to the admin. */
export const MISSING_LABELS: Record<string, string> = {
  legalName: 'billing.setup.missing.legalName',
  address: 'billing.setup.missing.address',
  bankAccountNumber: 'billing.setup.missing.bankAccountNumber',
  paymentCode: 'billing.setup.missing.paymentCode'
};
